import { useContext, useMemo, useRef, useState } from 'react';
import { TranslationContext } from '../../../assets/contexts/translationContext';
import BottomActionButton from '../../shared/BottomActionButton/BottomActionButton';
import BottomSheet from '../../shared/BottomSheet/BottomSheet';
import './RenameCardSheet.css';

function RenameCardSheet({ currentName, onClose, onSave }) {
  const { card, common } = useContext(TranslationContext);
  const initialName = currentName.trim();
  const [name, setName] = useState(initialName);
  const inputRef = useRef(null);
  const canSave = useMemo(() => {
    const nextName = name.trim();
    return nextName.length > 0 && nextName !== initialName;
  }, [initialName, name]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!canSave) return;
    onSave(name.trim());
  };

  return (
    <BottomSheet
      className="rename-card-sheet"
      title={card.renameCard}
      titleId="rename-card-sheet-title"
      onClose={onClose}
      onOpenComplete={() => {
        inputRef.current?.focus({ preventScroll: true });
        inputRef.current?.select();
      }}
    >
      <form className="rename-card-sheet__form" onSubmit={handleSubmit}>
        <label className="rename-card-sheet__field">
          <span className="rename-card-sheet__label">{card.cardName}</span>
          <input
            ref={inputRef}
            className="rename-card-sheet__input"
            type="text"
            value={name}
            enterKeyHint="done"
            maxLength={32}
            onChange={(event) => setName(event.target.value)}
          />
        </label>

        <BottomActionButton
          className="rename-card-sheet__save"
          type="submit"
          disabled={!canSave}
        >
          {common.save}
        </BottomActionButton>
      </form>
    </BottomSheet>
  );
}

export default RenameCardSheet;
